import React from "react";
import { Timer, Bike, Trophy } from "lucide-react";
import { FilaEntregador } from "../types";

interface FilaAguardandoProps {
  aguardando: FilaEntregador[];
}

export const FilaAguardando: React.FC<FilaAguardandoProps> = ({
  aguardando,
}) => {
  return (
    <div className="rounded-xl border border-white/20 bg-white/10 p-4 backdrop-blur-sm sm:rounded-2xl sm:p-6">
      <div className="mb-4 flex items-center justify-center sm:mb-6">
        <div className="mr-2 rounded-full bg-primary-dark p-2 sm:mr-3 sm:p-3">
          <Timer className="h-5 w-5 text-white sm:h-6 sm:w-6" />
        </div>
        <h2 className="text-xl font-bold sm:text-2xl lg:text-3xl">
          Aguardando ({aguardando.length})
        </h2>
      </div>

      {aguardando.length === 0 ? (
        <div className="py-8 text-center sm:py-12">
          <div className="mb-4 flex justify-center opacity-50">
            <Bike className="h-16 w-16 sm:h-24 sm:w-24" />
          </div>
          <p className="text-lg opacity-75 sm:text-xl">
            Nenhum entregador na fila
          </p>
        </div>
      ) : (
        <div className="max-h-64 space-y-3 overflow-y-auto sm:max-h-80 sm:space-y-4 lg:max-h-96">
          {aguardando.map((item, index) => (
            <div
              key={item.id}
              className={`rounded-lg p-3 transition-all duration-300 sm:rounded-xl sm:p-4 ${
                index === 0
                  ? "border border-green-400/40 bg-gradient-to-r from-green-500/30 to-green-600/20 shadow-lg"
                  : "border border-white/10 bg-white/5"
              }`}
            >
              <div className="flex items-center justify-between">
                <div className="flex items-center">
                  <div
                    className={`mr-2 flex h-8 w-8 items-center justify-center rounded-full sm:mr-3 sm:h-10 sm:w-10 lg:mr-4 lg:h-12 lg:w-12 ${
                      index === 0 ? "bg-yellow-500 shadow-lg" : "bg-white/20"
                    }`}
                  >
                    {index === 0 ? (
                      <Trophy className="h-4 w-4 text-white sm:h-5 sm:w-5 lg:h-6 lg:w-6" />
                    ) : (
                      <span className="text-sm font-bold text-white sm:text-base lg:text-lg">
                        {index + 1}
                      </span>
                    )}
                  </div>
                  <div>
                    <h3
                      className={`text-sm font-bold sm:text-lg lg:text-xl ${
                        index === 0 ? "text-yellow-300" : "text-white"
                      }`}
                    >
                      {item.nome}
                    </h3>
                    <p
                      className={`text-xs sm:text-sm ${
                        index === 0 ? "text-yellow-200" : "text-neutral-300"
                      }`}
                    >
                      {item.posicao != null
                        ? `Posição: ${item.posicao}`
                        : `${index + 1}º na fila`}
                    </p>
                  </div>
                </div>
                {index === 0 && (
                  <div className="text-yellow-300">
                    <Trophy className="h-5 w-5 sm:h-6 sm:w-6" />
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
